import React, { useEffect } from "react";
import { deleteDocById } from "../Firebase/Firebase.utils";
import toast from "react-hot-toast";
import NoPhoto from "../assets/No_Image_Available.jpg";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  FaMapMarkerAlt,
  FaBuilding,
  FaStar,
  FaInfoCircle,
  FaExternalLinkAlt,
} from "react-icons/fa";

function BuildingCard({ building }) {
  const [photos, setPhotos] = React.useState([]);
  const [isHovered, setIsHovered] = React.useState(false);
  const currentUser = useSelector((state) => state.userObject);

  const handleDelete = async () => {
    if (window.confirm("Are you sure you want to delete this building?")) {
      await deleteDocById("masterlist", building.id);
      toast.success("Building has been deleted");
    }
  };

  return (
    <div
      className="w-[280px] rounded-lg overflow-hidden bg-white border border-gray-100 shadow-sm hover:shadow-md transition-all duration-300 flex flex-col"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Link to={`/building/${building.id}`} className="flex flex-col h-full">
        {/* Image container with overlay for badges */}
        <div className="relative h-[180px]">
          <img
            className={`object-cover w-full h-full transition-all duration-500 ${
              isHovered ? "scale-105" : ""
            }`}
            src={building?.primaryPhotoUrl || NoPhoto}
            alt={building.buildingName}
          />

          {/* Exclusive badge */}
          {building.exclusive === "Yes" && (
            <div className="absolute top-3 right-3 z-10 flex items-center gap-1 bg-[#ff5003] px-2 py-1 rounded-full shadow-sm">
              <FaStar className="text-white text-xs" />
              <span className="font-medium text-white text-xs">Exclusive</span>
            </div>
          )}

          {/* City/Location badge */}
          <div className="absolute bottom-3 left-3 z-10 bg-white/80 backdrop-blur-sm px-2 py-1 rounded-md text-xs font-medium text-gray-800">
            {building.city || building.businessDistrict || "Location"}
          </div>
        </div>

        {/* Content area */}
        <div className="p-4 flex-1 flex flex-col">
          {/* Building name */}
          <div className="flex items-start gap-2 mb-3">
            <FaBuilding className="text-[#ff5003] mt-1 flex-shrink-0" />
            <h3 className="font-semibold text-gray-800 line-clamp-2">
              {building.buildingName}
            </h3>
          </div>

          {/* Address */}
          <div className="flex items-center gap-2 text-gray-600 mb-3">
            <FaMapMarkerAlt className="text-gray-400 flex-shrink-0" />
            <p className="text-sm truncate">{building.address}</p>
          </div>

          {/* Additional info */}
          <div className="mt-auto">
            {building.developer && (
              <div className="text-xs text-gray-500 mb-1">
                Developer:{" "}
                <span className="font-medium text-gray-700">
                  {building.developer}
                </span>
              </div>
            )}

            {building.yearConstructed && (
              <div className="text-xs text-gray-500">
                Built:{" "}
                <span className="font-medium text-gray-700">
                  {building.yearConstructed}
                </span>
              </div>
            )}
          </div>
        </div>
      </Link>

      {/* Action buttons - appears on hover */}
      <div
        className={`px-4 pb-4 transition-opacity duration-300 ${
          isHovered ? "opacity-100" : "opacity-0"
        }`}
      >
        <div className="flex items-center justify-between">
          <Link
            to={`/building/${building.id}`}
            className="flex items-center gap-1 bg-white border border-[#002368] text-[#002368] px-3 py-1.5 rounded-lg text-sm font-medium hover:bg-[#002368] hover:text-white transition-colors duration-200"
          >
            <FaInfoCircle size={14} /> Details
          </Link>

          {building.googleMapsPin && (
            <a
              href={building.googleMapsPin}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1 bg-[#002368] text-white px-3 py-1.5 rounded-lg text-sm font-medium hover:bg-[#ff5003] transition-colors duration-200"
              onClick={(e) => e.stopPropagation()}
            >
              <FaExternalLinkAlt size={12} /> Maps
            </a>
          )}
        </div>
      </div>
    </div>
  );
}

export default BuildingCard;
